export function createEditorController(adapter) {
    return {
        useProps(props) {
            return {
                state: props.initial,
                suggestion: props.suggestion,
                onUpdate(state) {
                    props.onUpdate(state);
                },
                onSelect(selection) {
                    props.onSelect(selection);
                },
                onSuggestionUpdate(suggestion) {
                    props.onSuggestionUpdate(suggestion);
                },
                onMount: props.onMount,
            };
        },
    };
}
//# sourceMappingURL=editorController.js.map